function isAnalytics() {
  return (typeof window.ga !== 'undefined');
}

function isMixPanel() {
  return (typeof window.mixpanel !== 'undefined');
}

module.exports = {
  sendEvent: function(action, label, data) {
    if(isAnalytics()) {
      ga('send', 'event', 'quoting-tool', action, label);
    }
    if(isMixPanel()) {
      mixpanel.track(action, {
        source: 'quoting-tool',
        label: label,
        ...data
      });
    }
  },
  sendPageEvent: function(label, data) {
    this.sendEvent('page-change-to', label, data);
  },
  sendDataEnteredEvent: function(label, data) {
    this.sendEvent('data-entered', label, data);
  }, 
  sendClickEvent: function(label, data) {
    this.sendEvent('clicked-on', label, data);
  },
  setUserId: function(userId) {
    if(isAnalytics()) {
      ga('set', 'userId', userId);
    }
  },
  setMixPanelPerson: function(email, name, phone) {
    if(isMixPanel()) {
      mixpanel.identify(email);
      mixpanel.people.set({'$email': email, '$created': new Date(),'$name': name, '$phone':phone});
    }
  }
}


// WEBPACK FOOTER //
// ./src/analytics.js